import httpServices from 'services/http.service';
import { API_URLS } from 'constants/index';

type UserEventType = 'preview' | 'addToCard' | 'checkoutPage' | 'checkoutProcess' | 'instagramClick' | 'tiktokClick' | 'productPreview' | 'checkoutPhone' | 'search' | 'viewAllCategoriesClick' | 'categoryClick' | 'filterClick';

const REFERRER_KEY = 'drop_referrer';

export const saveReferrer = (referrer: string) => {
  if (typeof window !== 'undefined') localStorage.setItem(REFERRER_KEY, referrer);
};

export const getReferrer = (): string | null => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(REFERRER_KEY);
};

const DEBOUNCE_MS = 1000;
const pendingTimers = new Map<UserEventType, ReturnType<typeof setTimeout>>();

export const trackEvent = (type: UserEventType, label?: string) => {
  const existing = pendingTimers.get(type);
  if (existing) clearTimeout(existing);

  const timer = setTimeout(() => {
    pendingTimers.delete(type);
    const referrer = getReferrer();
    void httpServices
      .post(API_URLS.USER_EVENT, { type, ...(label ? { label } : {}), ...(referrer ? { referrer } : {}) })
      .catch(() => null);
  }, DEBOUNCE_MS);

  pendingTimers.set(type, timer);
};
